import * as ACTION from 'actions';
import _, {cloneDeep} from 'lodash';

const defaultForm = {
    id: '',
    projectId: '',
    eventId: '',
    form: {
        images: {
            headerImage: '',
            backgroundImage: ''
        },
        terms: {
            title: '',
            body: ''
        },
        complete: {
            title: '',
            body: ''
        },
        input: []
    },
    startAt: '',
    endAt: ''
};

export function form(state=defaultForm, action) {
    if(action == null) return  state;
    let _form = cloneDeep(state);
    let index = -1;

    switch (action.type) {
        case ACTION.FETCH_FORM:
            return action.form;
        case ACTION.ADD_FORM_INPUT:
            _form.form.input.push(action.input);
            return _form;
        case ACTION.EDIT_FORM_INPUT:
            index = state.form.input.findIndex(data => data.id === action.input.id);
            _form.form.input[index] = action.input;
            return _form;
        case ACTION.DELETE_FORM_INPUT:
            index = state.form.input.findIndex(data => data.id === action.input.id);
            _form.form.input.splice(index, 1);
            return _form;
        case ACTION.EDIT_TERM:
            _form.form.terms[action.term.key] = action.term.value;
            return _form;
        case ACTION.EDIT_COMPLETE:
            _form.form.complete[action.data.key] = action.data.value;
            return _form;
        case ACTION.EDIT_IMAGE:
            _form.form.images[action.image.key] = action.image.value;
            return _form;
        case ACTION.DELETE_IMAGE:
            _form.form.images[action.image.key] = '';
            return _form;
        case ACTION.EDIT_START_AT:
            _form.startAt = action.startAt;
            return _form;
        case ACTION.EDIT_END_AT:
            _form.endAt = action.endAt;
            return _form;
        default:
            return state
    }
}

export function forms(state=[], action) {
    if(action == null) return  state;
    let _forms = Object.assign([], state);
    let index = -1;

    switch (action.type) {
        case ACTION.FETCH_FORM_LIST:
            return _.sortBy(action.forms, 'createdAt');
        case ACTION.ADD_FORM_LIST:
            return [...state,action.form];
        case ACTION.DELETE_FORM_LIST:
            index = state.findIndex(data => data.id === action.form.id);
            _forms.splice(index, 1);
            return _forms;
        default:
            return state
    }
}
